<template>
  <div class="package-wrap" @click="onPackageClick">
    <div class="package">
      <img
        class="package-img"
        src="@/assets/images/course/course-detail-package@2x.png"
      />
      <span class="package-text">
        打包买课，立享{{ course.package_discount_money / 100 }}元优惠
      </span>
      <img
        class="package-arrow"
        src="@/assets/images/course/course-detail-arrow@2x.png"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseShowPackage",
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onPackageClick() {
      this.$router.push({
        name: "Package",
        query: { course_id: this.course.id, course_name: this.course.title },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.package-wrap {
  height: 20px;
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.package {
  cursor: pointer;
  display: flex;
  align-items: flex-end;
}

.package-img {
  height: 20px;
}

.package-arrow {
  height: 12px;
  margin-bottom: 2px;
}

.package-text {
  font-size: 14px;
  color: $primary-color;
  padding: 0 9px;
  line-height: 1;
}
</style>
